import {
  endOfDay,
  startOfDay,
  isValid,
  addDays,
  startOfMonth,
  endOfMonth,
  subMonths,
  startOfYear,
  endOfYear,
  subYears
} from 'date-fns'

export const formatTimestamp = (
  timestamp,
  options = {
    weekday: 'long',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  }
) => new Date(timestamp).toLocaleString('ro', options)

export const getCompleteDateRange = (dateRange) => {
  if (!dateRange || !isValid(dateRange?.from) || !isValid(dateRange?.to))
    return undefined
  return { from: startOfDay(dateRange?.from), to: endOfDay(dateRange?.to) }
}

export const getTodayRange = () => {
  const today = new Date()
  const todayRange = { from: today, to: today }
  return getCompleteDateRange(todayRange)
}

export const getYesterdayRange = () => {
  const yesterday = addDays(new Date(), -1)
  const yesterdayRange = { from: yesterday, to: yesterday }
  return getCompleteDateRange(yesterdayRange)
}

export const getLastSevenDaysRange = () => {
  const sevenDaysAgo = addDays(new Date(), -6)
  const lastSevenDaysRange = { from: sevenDaysAgo, to: new Date() }
  return getCompleteDateRange(lastSevenDaysRange)
}

export const getLastThirtyDaysRange = () => {
  const thirtyDaysAgo = addDays(new Date(), -29)
  const lastThirtyDaysRange = { from: thirtyDaysAgo, to: new Date() }
  return getCompleteDateRange(lastThirtyDaysRange)
}

export const getCurrentMonthRange = () => {
  const startOfMonthDay = startOfMonth(new Date())
  const endOfMonthDay = endOfMonth(new Date())
  const currentMonthRange = { from: startOfMonthDay, to: endOfMonthDay }
  return getCompleteDateRange(currentMonthRange)
}

export const getLastMonthRange = () => {
  const aMonthAgo = subMonths(new Date(), 1)
  const startOfMonthDay = startOfMonth(aMonthAgo)
  const endOfMonthDay = endOfMonth(aMonthAgo)
  const lastMonthRange = { from: startOfMonthDay, to: endOfMonthDay }
  return getCompleteDateRange(lastMonthRange)
}

export const getCurrentYearRange = () => {
  const startOfYearDay = startOfYear(new Date())
  const endOfYearDay = endOfYear(new Date())
  const currentYearRange = { from: startOfYearDay, to: endOfYearDay }
  return getCompleteDateRange(currentYearRange)
}

export const getLastYearRange = () => {
  const aYearAgo = subYears(new Date(), 1)
  const startOfYearDay = startOfYear(aYearAgo)
  const endOfYearDay = endOfYear(aYearAgo)
  const lastYearRange = { from: startOfYearDay, to: endOfYearDay }
  return getCompleteDateRange(lastYearRange)
}
